//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 export default {
  name: 'service',
  data(){
    return{
      //公司名
      cname:"",
      //職位
      job:"",
      //姓名
      name:"",
      //邮箱
      email:"",
      code_value:"",
      tel:""
    }
  },
  created: function(){
    //初始化执行的方法
    this.cname = this.$route.params.cname;
    this.job = this.$route.params.job;
    this.name = this.$route.params.name;
    this.email = this.$route.params.email;
    this.code_value = this.$route.params.code_value;
    this.tel = this.$route.params.tel;

/*    console.log(
      "cname :"+ this.cname +
      "job :"+ this.job +
      "name :"+ this.name +
      "email :"+ this.email +
      "code_value :"+ this.code_value +
      "tel :"+ this.tel
      )*/

  },
  methods :{
  	 back:function(){
      this.$router.push({
        name: 'init', 
        params: {
        	cname:this.cname,
        	job:this.job,
        	name:this.name,
        	email:this.email,
          code_value:this.code_value,
          tel:this.tel,
        }})
    },
  }
  }



// WEBPACK FOOTER //
// ./src/views/service/index.vue